<template>
    <Reviews :id="id"/>
</template>
<script>
import Reviews from '@/components/Reviews.vue';

export default {
    name: 'ReviewsProfile',
    components: {
        Reviews
    },
    data() {
        return {
            id: null,
        }   
    },
    mounted() {
        this.id = this.$route.params.id ? +this.$route.params.id : null;
    },
}
</script>
